import EbaRetailCalculator from "@/components/shared/eba-retail-calculator/eba-retail";
import { HomePage } from "../type/type";

export default function EbaRetailSection({ data }: { data: HomePage | undefined }) {
  return (
    <div className="max-w-7xl mx-auto">
      <EbaRetailCalculator
        calculatorTitle={data?.calculator_title}
        calculatorDesc={data?.calculator_desc}
        buttonText={data?.calculator_button_text}
        buttonUrl={data?.calculator_button_url}
        amountLabel={data?.calculator_label_amount}
        couponLabel={data?.calculator_label_coupon}
        submitLabel={data?.calculator_label_submit}
        couponOptions={data?.calculator_coupon_options}
      />
    </div>
  );
}
